export const convertNumericValue = (value: string | null) => {
  if (value === "" || value === null || value === undefined) {
    return null;
  }
  return value;
};

export const numericField = (v: FormDataEntryValue | null): string => {
  if (v === null || v === undefined || String(v).trim() === "") return "0";
  return String(v);
};

export const optionalField = (
  v: FormDataEntryValue | null
): string | undefined => {
  if (v === null || v === undefined || String(v).trim() === "")
    return undefined;
  return String(v);
};
